import React, { useEffect } from 'react';
import classnames from 'classnames';
import LandingPage from '../js/components/pages/LandingPage.jsx';
import SurveyPage from '../js/components/pages/SurveyPage.jsx';
import SummaryPage from '../js/components/pages/SummaryPage.jsx';
import DetailsPage from '../js/components/pages/DetailsPage.jsx';
import Header from '../js/components/Header.jsx';
import ProgressBar from "../js/components/ProgressBar.jsx";
import {GuideAppContainer, PageContainer, RenderOnlyFor, updateProductCart, useDispatch, useProducts, usePages } from "@ignitesales/neuro-application";

const BranchThemeApp = () => {

  const bemClass = 'pageContainer';
  const pageClasses = classnames(`${bemClass}`);
  const dispatch = useDispatch();
  const { productCart } = useProducts();
  const { currentPageType } = usePages();

  useEffect(() => {
    if(currentPageType === 'survey' && productCart && productCart.size > 0) {
      productCart.forEach( product => {
        dispatch(updateProductCart(productCart, product, true));
      });
    };
  }, [currentPageType, productCart]);
  

  return (
    <GuideAppContainer>
      <Header>
        <RenderOnlyFor forSurveyPage={true}>
            <ProgressBar />
        </RenderOnlyFor>
      </Header> 
      <PageContainer
        LandingPage={LandingPage}
        SurveyPage={SurveyPage}
        SummaryPage={SummaryPage}
        DetailsPage={DetailsPage}
        className={pageClasses}
      />
    </GuideAppContainer>
  );
};

export default BranchThemeApp;
